<script>
    import { projectSettings } from '../config';
</script>

<a title="Email {projectSettings.emailAddress}" href="mailto:{projectSettings.emailAddress}" target="_blank">
    {projectSettings.emailAddress}
</a>

